/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Record_string_unknown_ } from './Record_string_unknown_';
/**
 * From T, pick a set of properties whose keys are in the union K
 */
export type Pick_BackgroundTaskAttributes_Exclude_keyofBackgroundTaskAttributes_result_or_error__ = {
    /**
     * The unique ID of the task.
     */
    id: number;
    /**
     * A computed column with a string representation of the current status.
     */
    status: Pick_BackgroundTaskAttributes_Exclude_keyofBackgroundTaskAttributes_result_or_error__.status;
    /**
     * Timestamp when the task was created.
     */
    created_on: string;
    /**
     * User ID of who requested the Task.
     */
    user_id: string;
    /**
     * Name of the operation to execute.
     */
    name: string;
    /**
     * A JSON object with extra information about the task.
     */
    context: Record_string_unknown_ | null;
    /**
     * Timestamp when the Task execution has started.
     */
    started_on: string | null;
    /**
     * Timestamp when the Task execution has finished.
     */
    finished_on: string | null;
    /**
     * Timestamp when user read the task results.
     */
    finished_read_on: string | null;
};
export namespace Pick_BackgroundTaskAttributes_Exclude_keyofBackgroundTaskAttributes_result_or_error__ {
    /**
     * A computed column with a string representation of the current status.
     */
    export enum status {
        QUEUED = 'queued',
        PENDING = 'pending',
        COMPLETE = 'complete',
        FAILURE = 'failure',
    }
}

